function ready() {
// Reveal JS
  sr.reveal('.hideme-hero', { 
    duration: 1000,
    opacity: 0,
    distance: 0,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });
  sr.reveal('.hideme', { 
    duration: 1000,
    opacity: 0,
    distance: 0,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });  
  sr.reveal('.hideme-bottom', { 
    duration: 1000,
    opacity: 0,
    distance: 0,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });
  sr.reveal('.hideme-delayed-long', { 
    duration: 1000,
    delay: 200,
    opacity: 0,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });  
  sr.reveal('.hideme-delayed', { 
    duration: 400,
    delay: 200,
    opacity: 0,
    scale: 1.5,
    mobile: false,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });
  sr.reveal('.hideme-delayed-2', { 
    duration: 500,
    delay: 300,
    opacity: 0,
    scale: 1.7,
    mobile: false,    
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });
  sr.reveal('.hideme-delayed-3', { 
    duration: 500,
    delay: 450,
    opacity: 0,
    scale: 1.5,
    mobile: false,    
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  }); 
  sr.reveal('.hideme-delayed-4', { 
    duration: 500,
    delay: 500,
    opacity: 0,
    scale: 1,
    mobile: false,    
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });   
  sr.reveal('.hideme-delayed-5', { 
    duration: 500,
    delay: 550,
    opacity: 0,
    scale: 1.5,
    mobile: false,    
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  }); 
  sr.reveal('.hideme-delayed-6', { 
    duration: 500,
    delay: 600,
    opacity: 0,
    scale: 1.7,
    mobile: false,    
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });   
  sr.reveal('.hideme', { 
    container: '.logo-bar',
    duration: 650,
    scale: 0,
    opacity: 0,
    scale: 2,
    mobile: false,    
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
  });
}
// Wait for document to load
document.addEventListener("DOMContentLoaded", ready);